import React, {useState, useEffect} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col } from "react-bootstrap"
import { getCloudImageUrl } from "../../../utils"
import {CollectionParent} from "../Section"

const CollectionParent2 = ({title, slug, category, history, images, children, isPreVerified}) => {

  return (
    <Container fluid className="container-parent-section2">
      <Row className="row-parent-header">
        <div style={{backgroundImage: `url(${getCloudImageUrl(images.URL, 2000)})`}}>
        </div>
      </Row>
      <div className="row-parent-slider">
        <CollectionParent 
          children={children}
          category={category}
          isCollectionWithImage
          history={history}
          slug={slug}
          noShadow
          isPreVerified={isPreVerified}
        />
      </div>
    </Container>
  )
}

export default CollectionParent2
